<template>
    <padded-container
        class="vf-cta-state-container"
        :size="largeSize"
        is-bordered
    >
        <announce-layout
            :title="title"
            :subtitle="subtitle"
        >
            <template slot="header">
                <slot name="icon">
                    <vf-no-data-icon
                        v-if="isNoData"
                        class="vf-icon-extra-large"
                    />
                    <vf-checkmark-icon
                        v-if="isSuccess"
                        class="vf-icon-extra-large vf-success"
                        :circle="filled"
                    />
                    <vf-exclamation-mark-icon
                        v-if="isError"
                        class="vf-icon-extra-large vf-error"
                        :circle="filled"
                    />
                </slot>
            </template>
            <template slot="footer">
                <slot>
                    <div class="vf-announce-layout__buttons-wrapper">
                        <moderation-control
                            v-for="action in actions"
                            :key="action.key"
                            :text="action.text"
                            @click.native.passive="$emit('cta-clicked', action.key)"
                        />
                    </div>
                </slot>
            </template>
        </announce-layout>
    </padded-container>
</template>

<script>
import { ICON_STATUSES } from '@/constants/moderation.js';
import { SIZES } from 'design-assets/components/buttons/constants.js';
import { vfNoDataIcon } from 'design-assets/components/svg/icons/no_data.c.js';
import announceLayout from 'design-assets/components/layout/announce-layout.vue';
import paddedContainer from 'design-assets/components/container/padded-container.vue';
import moderationControl from './ModerationControl.vue';
import { vfCheckmarkIcon } from 'design-assets/components/svg/icons/checkmark_icon.c.js';
import { vfExclamationMarkIcon } from 'design-assets/components/svg/icons/exclamation_mark.c.js';
import { CIRCLE } from 'design-assets/components/svg/icon/icon.js';
import VueTypes from 'commons/util/vue-types.js';

export default {

    props: {
        title: VueTypes.string,
        subtitle: VueTypes.string,
        status: VueTypes.string.def(ICON_STATUSES.NONE).validate((status) => Object.values(ICON_STATUSES).includes(status)),
        actions: VueTypes.array,
    },

    beforeCreate() {
        this.filled = CIRCLE.filled;
        this.largeSize = SIZES.LARGE;
    },

    computed: {
        isSuccess() {
            return this.status === ICON_STATUSES.SUCCESS;
        },
        isError() {
            return this.status === ICON_STATUSES.ERROR;
        },
        isNoData() {
            return this.status === ICON_STATUSES.NONE;
        },
    },

    components: {
        vfNoDataIcon,
        vfCheckmarkIcon,
        vfExclamationMarkIcon,
        moderationControl,
        announceLayout,
        paddedContainer,
    },
};
</script>

<style lang="scss">
.vf-cta-state-container {
    margin-top: 1rem;
}

.vf-announce-layout {
    margin-top: 1.5rem;
    margin-bottom: 1.5rem;
    min-width: 50rem;
}

.vf-announce-layout__title {
    font-weight: 300;
}

.vf-announce-layout__buttons-wrapper {
    margin-top: 2rem;

    .vf-moderation__control {
        height: 3.5rem;
        width: 15rem;

        &:first-child {
            margin-right: 2rem;
        }
    }
}
</style>
